import { create } from 'zustand';

interface AuthUser {
    username: string;
    roles: string[];
    permissions: string[];
    platformAdmin: boolean;
}

interface AuthState {
    token: string | null;
    user: AuthUser | null;
    setAuth: (token: string, user: AuthUser) => void;
    logout: () => void;
}

function loadUserFromStorage(): AuthUser | null {
    try {
        const raw = localStorage.getItem('user');
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        // Validate new format (must have roles array)
        if (Array.isArray(parsed.roles) && Array.isArray(parsed.permissions)) {
            return parsed;
        }
        // Old format detected — clear stale data, force re-login
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        return null;
    } catch {
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        return null;
    }
}

export const useAuthStore = create<AuthState>((set) => ({
    token: localStorage.getItem('token'),
    user: loadUserFromStorage(),
    setAuth: (token, user) => {
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(user));
        set({ token, user });
    },
    logout: () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        set({ token: null, user: null });
    },
}));
